<script>
import BaseContent from "./BaseContent.vue";
import BasePill from "./BasePill.vue";

export default {
    name: "CharacterDomain",
    components: { BasePill, BaseContent },
    props: {
        domain: {
            type: Object,
            required: true,
        },
    },
};
</script>

<template>
    <BaseContent>
        <template #header
            >{{ domain.name }}
            <BasePill class="h-fit">Domain</BasePill>
        </template>
        {{ domain.description }}
    </BaseContent>
</template>

<style scoped></style>
